/* unplugin-vue-components disabled */import { ElRadioGroup as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/radio-group/style/css';
import { ElRadioButton as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/radio-button/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-587669a1"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_createTextVNode("使用教程");
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Windows");
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Mac OS");
const _hoisted_4 = {
  class: "container"
};
const _hoisted_5 = {
  class: "marginB20"
};
import { apiGetPackSource } from '@/api/pack';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const macDownloadUrl = ref('');
    const winDownloadUrl = ref('');
    const macVersion = ref('');
    const winVersion = ref('');
    const currentTab = ref('win');
    const currentVersion = ref();
    const downloadUrl = ref();
    const SDK_NAME = process.env.VUE_APP_SDK_NAME;
    const handleChangeTab = e => {
      if (process.env.VUE_APP_PLAT !== 'ultra') {
        if (e === 'mac') {
          downloadUrl.value = process.env.VUE_APP_MAC_DOWNLOAD_URL;
          currentVersion.value = process.env.VUE_APP_PACK_VERSION;
        }
        if (e === 'win') {
          downloadUrl.value = process.env.VUE_APP_WIN_DOWNLOAD_URL;
          currentVersion.value = process.env.VUE_APP_PACK_VERSION;
        }
        return;
      }
      if (e === 'mac') {
        downloadUrl.value = macDownloadUrl.value;
        currentVersion.value = macVersion.value;
      }
      if (e === 'win') {
        downloadUrl.value = winDownloadUrl.value;
        currentVersion.value = winVersion.value;
      }
    };
    const handleToDoc = () => {
      window.open(process.env.VUE_APP_OFFICIAL_DOC_2, '__blank');
    };
    const handleDownload = () => {
      window.open(downloadUrl.value);
    };
    const getPackResource = async () => {
      const res = await apiGetPackSource({
        target: 2
      });
      if (res.code === 0) {
        res.data.forEach(item => {
          if (item.platform === 1) {
            winDownloadUrl.value = item.middle_bag;
            winVersion.value = item.version;
            currentVersion.value = item.version;
            return;
          }
          if (item.platform === 2) {
            macDownloadUrl.value = item.middle_bag;
            macVersion.value = item.version;
          }
        });
      }
    };
    onMounted(() => {
      if (process.env.VUE_APP_PLAT === 'ultra') {
        getPackResource();
      } else {
        currentVersion.value = process.env.VUE_APP_PACK_VERSION;
        winDownloadUrl.value = process.env.VUE_APP_WIN_DOWNLOAD_URL;
        macDownloadUrl.value = process.env.VUE_APP_MAC_DOWNLOAD_URL;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_radio_button = __unplugin_components_1;
      const _component_el_radio_group = __unplugin_components_2;
      const _component_u_card = _resolveComponent("u-card");
      return _openBlock(), _createBlock(_component_u_card, {
        title: "本地打包工具下载",
        disabled: ""
      }, {
        extra: _withCtx(() => [_createVNode(_component_el_button, {
          class: "marginR20",
          link: "",
          type: "primary",
          onClick: handleToDoc
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_radio_group, {
          modelValue: currentTab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => currentTab.value = $event),
          onChange: handleChangeTab
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_button, {
            label: "win"
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          }), _createVNode(_component_el_radio_button, {
            label: "mac"
          }, {
            default: _withCtx(() => [_hoisted_3]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("h3", _hoisted_5, _toDisplayString(_unref(SDK_NAME)) + " 本地打包工具（" + _toDisplayString(currentVersion.value) + "）", 1), _createVNode(_component_el_button, {
          style: {
            "width": "300px",
            "height": "50px",
            "font-size": "20px"
          },
          type: "primary",
          onClick: handleDownload
        }, {
          default: _withCtx(() => [_createTextVNode("下载（" + _toDisplayString(currentTab.value === 'win' ? 'Windows' : 'Mac OS') + "）", 1)]),
          _: 1
        })])]),
        _: 1
      });
    };
  }
});